import type { LocationRecord } from '@libs/data-access/entities'
import type { ShiftRecord } from '@libs/data-access/queries'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import { useMemoSelector } from '@spa/redux/hooks'
import { formatToIsoDay } from '@spa/utils/date'
import moment from 'moment'
import { getCurrentAccount } from 'snap-redux/modules/accounts/selectors'
import { getContractById } from 'snap-redux/modules/contracts/selectors'

import type FormData from '../Models/FormData'
import { canSetAutomaticBreaks } from '../utils/canSetAutomaticBreaks'
import getBreaksLegacy from '../utils/getBreaksLegacy'
import getMealsLegacy from '../utils/getMealsLegacy'

import useGetDefaultUserContractLegacy from './useGetDefaultUserContractLegacy'

type Props = {
  shift: ShiftRecord
  teamId: number
  labelId: number
  weeklyScheduleIsPublished: boolean
  selectedTeamLocation?: LocationRecord
  weeklyscheduleLocation: LocationRecord
}

/**
 * @deprecated please don't use it
 */
const useShiftDefaultValuesLegacy = ({
  shift,
  weeklyscheduleLocation,
  teamId,
  labelId,
  weeklyScheduleIsPublished,
  selectedTeamLocation
}: Props): FormData => {
  const account = useMemoSelector(getCurrentAccount)
  const contract = useMemoSelector(state =>
    getContractById(state, shift.user_contract_id)
  )

  const { tDates } = usePlanningFormTranslation()

  const momentStart = moment(shift.starts_at)
  const momentEnd = moment(shift.ends_at)
  const shiftStartDate = moment(shift.starts_at).format('YYYY-MM-DD')

  const automaticBreaksEnabled = canSetAutomaticBreaks(weeklyscheduleLocation, [
    momentStart.format('HH:mm'),
    momentEnd.format('HH:mm')
  ])
  const defaultBreakDuration = automaticBreaksEnabled
    ? Number(weeklyscheduleLocation.default_break_duration)
    : 0

  return {
    label: { value: labelId || shift.label_id || '' },
    user_contract: [useGetDefaultUserContractLegacy({ contract, shift })],
    shift_time_range: shift.id
      ? [momentStart.format('HH:mm'), momentEnd.format('HH:mm')]
      : ['__:__', '__:__'],
    breaks: getBreaksLegacy(
      defaultBreakDuration,
      shift?.shift_breaks,
      shift?.id
    ),
    meals: getMealsLegacy(
      account.meal_by_default_for_real,
      weeklyscheduleLocation.default_meal_type,
      shift?.shift_meals,
      shift?.id
    ),
    note: shift.note || '',
    notify_user: weeklyScheduleIsPublished,
    team: { value: teamId },
    location: {
      value:
        (selectedTeamLocation && selectedTeamLocation.id) ||
        (weeklyscheduleLocation && weeklyscheduleLocation.id)
    },
    update_day: {
      value: formatToIsoDay(shift.starts_at),
      label: tDates('dates.literalDate', { date: shift.starts_at })
    },
    days: [
      {
        value: shiftStartDate,
        label: tDates('dates.literalDate', { date: shiftStartDate })
      }
    ]
  }
}

export default useShiftDefaultValuesLegacy
